import { useEffect, useRef, useState } from "react";

import { getStationDetails } from "../services/stations";

export type StationVisibility = "PUBLIC" | "PRIVATE" | "UNKNOWN";

export const toVisibility = (publish: unknown): StationVisibility => {
  if (publish === true) return "PUBLIC";
  if (publish === false) return "PRIVATE";
  return "UNKNOWN";
};

/** Resolves each station's OCPI publish flag to a visibility, looking every station up once. */
export const useStationVisibility = (
  locationIds: string[],
): Record<string, StationVisibility | undefined> => {
  const [visibility, setVisibility] = useState<Record<string, StationVisibility>>({});
  const requested = useRef(new Set<string>());
  const mounted = useRef(true);
  const key = Array.from(new Set(locationIds.filter(Boolean))).sort().join("\n");

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    const pending = key.split("\n").filter((id) => id && !requested.current.has(id));
    pending.forEach((id) => {
      requested.current.add(id);
      getStationDetails(id)
        .then((details: any) => toVisibility(details?.publish))
        .catch((): StationVisibility => "UNKNOWN")
        .then((value: StationVisibility) => {
          if (mounted.current) setVisibility((previous) => ({ ...previous, [id]: value }));
        });
    });
  }, [key]);

  return visibility;
};
